import { PdfPageFormatType } from '@gucci/enums';
import { PdfPageSize } from './pdf-page-size';
import { keyBy } from '@gucci/shared/utils-lodash-replacement';

export const PDF_PAGE_SIZES: PdfPageSize[] = [
  {
    name: PdfPageFormatType.A0,
    sizeInInches: {
      width: 33.1,
      height: 46.8,
    },
  },
  {
    name: PdfPageFormatType.A1,
    sizeInInches: {
      width: 23.4,
      height: 33.1,
    },
  },
  {
    name: PdfPageFormatType.A2,
    sizeInInches: {
      width: 16.54,
      height: 23.4,
    },
  },
  {
    name: PdfPageFormatType.A3,
    sizeInInches: {
      width: 11.7,
      height: 16.54,
    },
  },
  {
    name: PdfPageFormatType.A4,
    sizeInInches: {
      width: 8.27,
      height: 11.7,
    },
  },
  {
    name: PdfPageFormatType.A5,
    sizeInInches: {
      width: 5.83,
      height: 8.27,
    },
  },
  {
    name: PdfPageFormatType.A6,
    sizeInInches: {
      width: 4.13,
      height: 5.83,
    },
  },
  {
    name: PdfPageFormatType.LETTER,
    sizeInInches: {
      width: 8.5,
      height: 11,
    },
  },
  {
    name: PdfPageFormatType.LEGAL,
    sizeInInches: {
      width: 8.5,
      height: 14,
    },
  },
  {
    name: PdfPageFormatType.TABLOID,
    sizeInInches: {
      width: 11,
      height: 17,
    },
  },
  {
    name: PdfPageFormatType.LEDGER,
    sizeInInches: {
      width: 17,
      height: 11,
    },
  },
];

export const PDF_PAGE_SIZES_MAP = keyBy(PDF_PAGE_SIZES, 'name');
